module.exports = __webpack_public_path__ + "static/headshot-c08ee32b6693ec63a0111264eec8b430.jpg";